var render, staticRenderFns
import script from "./Wdmr.vue?vue&type=script&lang=js&"
export * from "./Wdmr.vue?vue&type=script&lang=js&"
import style0 from "./Wdmr.vue?vue&type=style&index=0&id=8640c7e2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports